import { getPlatformCategories } from '@/services/platformApi/publicCatalogApi';

export interface CategoryData {
  id: string;
  name: string;
}

/**
 * Fetch all categories ordered by name
 */
export async function getAllCategories(): Promise<string[]> {
  const data = await getPlatformCategories();
  return data.map((category) => category.name);
}

/**
 * Fetch full category data ordered by name
 */
export async function getAllCategoriesWithId(): Promise<CategoryData[]> {
  return getPlatformCategories();
}
